export default __webpack_public_path__ + "static/media/floorplan.df73242c.jpg";